module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0719.76547b74.jpg";